import { createContext } from "react";

import type { MenuItemContextProps, MenuItemMetadata } from "./Menu";

export const MenuContext = createContext<{
  registerItem: (id: string, metadata: MenuItemMetadata) => void;
  unregisterItem: (id: string) => void;
  getItemProps: (id: string) => MenuItemContextProps;
} | null>(null);
